import React, { useMemo } from 'react';
import { Body1 } from '@xo-union/tk-ui-typography';
import { varCoolgray200 } from '../../helpers/chartColors';
import { Gds_QuestionResponseData } from '../../generated/graphql';
import { Badge, ChartLabel } from './utils';
import styles from './rsvpSummaryCard.scss';
import Chart from './RsvpChart';

interface Props {
  data: Gds_QuestionResponseData;
  colors: string[];
}

/**
 * Renders answer options and total count
 * Assigns colors to options
 * Loops through color array if number of options are more than number of available colors
 */
const renderOptions = (data: Gds_QuestionResponseData['answersData'], colors: string[]) => {
  let i = 0;
  const options: any[] = [];
  data?.forEach((option: any) => {
    options.push(
      <div key={option.optionId} className={styles.option}>
        <Badge color={colors.length ? colors[i] : varCoolgray200} />
        <div className={styles.label}>{option.text}</div>
        <div className={styles.count}>{option.responseCount}</div>
      </div>
    );

    i = (i + 1) % colors.length;
  });

  return <div className={styles.optionsContainer}>{options.length ? options : null}</div>;
};

const OptionDataResponseCard: React.FC<Props> = ({ data, colors }) => {
  const totalCount = useMemo(() => data.answersData?.reduce((a, b) => a + (b!.responseCount || 0), 0), [
    data.answersData,
  ]);

  if (!data?.answersData?.length) return null;

  return (
    <div className={styles.optionAnswerCardContainer}>
      <Body1 bold className={styles.question}>
        {data.text}
      </Body1>
      <Chart id={`chart-${data.questionId}`} data={data.answersData} label="text" value="responseCount" colors={colors}>
        <ChartLabel responses={totalCount} total={0} isPrivateRsvp={false} />
      </Chart>
      <div className={styles.responses}>{renderOptions(data.answersData, colors)}</div>
    </div>
  );
};

export default OptionDataResponseCard;
